if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.productInfo = this.closest('product-info');
        this.estimatedShipping = this.productInfo.querySelector('estimated-shipping-label');

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const shippingName = `properties[${window.variantStrings.shipping}]`;
        const productInfo = this.closest('product-info');
        const estimatedShipping = productInfo.querySelector('estimated-shipping-label');
        const diasProduccionContainer = productInfo.querySelector('.product__sku');
        const diasProduccion =
          diasProduccionContainer.getAttribute('data-produccion') != ''
            ? diasProduccionContainer.getAttribute('data-produccion')
            : 0;
        if (estimatedShipping) {
          const shippingValue = estimatedShipping.getAttribute('estimated-date');
          formData.append(shippingName, shippingValue);
          formData.append('properties[__stock]', 'false');
        } else {
          const today = new Date();
          const threeDaysLater = this.addWorkingDays(today, 3);
          const fiveDaysLater = this.addWorkingDays(today, 5);

          const threeDaysFormatted = this.formatDate(threeDaysLater);
          const fiveDaysFormatted = this.formatDate(fiveDaysLater);

          const shippingValue = `${threeDaysFormatted}-${fiveDaysFormatted}`;
          formData.append(shippingName, shippingValue);
          formData.append('properties[__stock]', 'true');
        }
        formData.append('properties[__productionTime]', estimatedShipping ? diasProduccion : 0);
        formData.append('properties[__add_date]', new Date().toISOString().split('T')[0]);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())

          .then((response) => {
            var cartContents = jQuery.getJSON('/cart.js', function (cart, textStatus) {
              var carttext = cart.item_count;
              jQuery('.drawer__heading-count').text(`(${carttext})`);
              jQuery('.rocket-header__desktop-nav__links-count').text(`${carttext}`);
              jQuery('.rocket-header__desktop-nav__links-count-mb').text(`${carttext}`);
            });
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            const openHamburguer = document.getElementById('openHamburguerMobile');
            const closeHamburguer = document.getElementById('closeHamburguerMobile');
            let empty = this.cart.querySelector('.is-empty');
            this.submitButton.classList.remove('loading');
            if (this.cart && empty != null) {
              empty.classList.remove('is-empty');
              document.querySelector('.drawer__inner-empty').style.display = 'none';
              document.querySelector('.drawer__footer-empty').style.display = 'none';
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            document.querySelector('cart-drawer').classList.add('is-open');

            document.querySelector('cart-drawer').classList.remove('is-empty');
            document.body.classList.add('fix');

            closeHamburguer.style.display = 'block';
            openHamburguer.style.display = 'none';
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      addWorkingDays(startDate, daysToAdd) {
        const result = new Date(startDate);
        let addedDays = 0;

        while (addedDays < daysToAdd) {
          result.setDate(result.getDate() + 1);
          if (result.getDay() !== 0 && result.getDay() !== 6) {
            addedDays++;
          }
        }
        return result;
      }
      formatDate(date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        return `${day}/${month}`;
      }
    }
  );
}
